import { DndProvider as ReactDndProvider } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';

export const DndProvider = ({ children }: any) => {
  return <ReactDndProvider backend={HTML5Backend}>{children}</ReactDndProvider>;
};
